import {
    Component,
    OnInit,
    ChangeDetectorRef,
    AfterViewChecked
} from '@angular/core';
import { SharedService } from '../shared.service';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit, AfterViewChecked {
    public env: String = this.sharedService.getEnvironment();

    constructor(
        private sharedService: SharedService,
        private changeDetector: ChangeDetectorRef
    ) {}

    ngOnInit() {}

    isDisabled(step) {
        return this.sharedService.isValidStep(step);
    }

    ngAfterViewChecked() {
        this.changeDetector.detectChanges();
    }
}
